exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-attachment-file,\n.project-attachment-img {\n    display: inline-block;\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 4rem;\n    height: 4rem;\n    overflow: hidden;\n}\n.project-attachment-file {\n    display: inline-block;\n    text-align: center;\n    line-height: 4rem;\n}\n.project-attachment .media-body {\n    display: inline-block;\n}\n", ""]);

// exports
